import {Button, Loading} from '@startlibs/components'
import { getColor } from '@startlibs/utils';
import React from 'react'
import styled from 'styled-components';

import {RecordStatus} from '../lib/utils/recordEnums'

const Header = styled.div`
  display: flex;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${getColor('gray240')};
  align-items: center;
`
const HeaderTitle = styled.span`
  font-size: 15px;
  font-weight: bold;
  margin-right: 0.75rem;
`
const UploadingRecords = styled.span`
  padding: 0.25rem 0.75rem 0.25rem 0.5rem;
  background-color: ${getColor('lightBlue')};
  border-radius: 5px;
  font-weight: 600;
  display: flex;
  align-items: center;
  min-height: 24px;
  .link {
    margin-left: 0.5rem;
    font-size: 11px;
  }
  ${Loading} {
    margin-right: 0.5rem;
  }
`

export const HeaderInfo = ({records,data,openUploadLog}) => {
  const isUploading = records.find(({status}) => status === RecordStatus.Uploading || status === RecordStatus.Waiting)

  return <Header>
    <HeaderTitle>
      {records.length > 0 ? <>{records.length} {records.length > 1 ? "studies" : "study"} uploaded</> : "Upload your studies here"}
    </HeaderTitle>
      {isUploading 
        ? <UploadingRecords><Loading size={16} borderWidth={3}/>Uploading <a className="link activity-log-link" onClick={openUploadLog}>Upload log</a></UploadingRecords> 
        : data.isProcessing > 0 && data.activated 
          ? <a className="link activity-log-link" onClick={openUploadLog}>Upload log</a>
          : null}
  </Header>
}

